<div class="main-container"
[ngClass]="{'h-100' : isLinkTurnedOff}">
    <app-loader [isLoading]="loading"></app-loader>
    <div class="appointment-container w-100">
        <div>
            <app-customer-boooking-header [data]="headData" [isLinkOff]="isLinkTurnedOff"></app-customer-boooking-header>
        </div>
        <div class="wbg">
            <div *ngIf="!isLimitReached && !isProductBlocked && !isLinkTurnedOff" class="col">
                <label *ngIf="category.length" class="cat-label">Select Category</label>
                <div *ngIf="category.length" class="row">
                    <div *ngFor="let cat of category; let i=index">
                        <div class="category" [ngClass]="{'active-cat': cat.active === true}" (click)="selectCategory(i)">{{cat.category_name}}</div>
                    </div>
                </div>
                <label class="cat-label mt-3">Select Appointment Type</label>
                <div *ngIf="!isMobileView" class="cat-type-container row mt-3">
                    <div class="appintment-type col" [ngClass]="{'active-type': this.selectedType == 1}" (click)="selectAppointmentType(1)"
                        [ngClass]="{'red-error-class' : isSubmitted && !selectedType}">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="inquiry" id="inquiry"
                                value="1" [checked]="selectedType == 1">
                            <label class="form-check-label w-100" for="inquiry">
                              {{enquiryTitle}}
                            </label>
                            <label class="typ-desc" for="inquiry">
                              {{enquiryDescription}}
                            </label>
                          </div>
                    </div>

                    <div class="appintment-type col" [ngClass]="{'active-type': this.selectedType == 2}" (click)="selectAppointmentType(2)"
                        [ngClass]="{'red-error-class' : isSubmitted && !selectedType}">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="booking" id="booking"
                                value="2" [checked]="selectedType == 2">
                            <label class="form-check-label w-100" for="booking">
                              {{bookingTitle}}
                            </label>
                            <label class="typ-desc" for="booking">
                              {{bookingDescription}}
                            </label>
                        </div>
                    </div>
                </div>
                <div *ngIf="isMobileView" class="row mt-3 cat-type-container">
                    <div class="appintment-type col-12" [ngClass]="{'active-type': this.selectedType == 1}" (click)="selectAppointmentType(1)"
                        [ngClass]="{'red-error-class' : isSubmitted && !selectedType}">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="inquiry" id="inquiry"
                                value="1" [checked]="selectedType == 1">
                            <label class="form-check-label w-100" for="inquiry">
                              {{enquiryTitle}}
                            </label>
                            <label class="typ-desc" for="inquiry">
                              {{enquiryDescription}}
                            </label>
                        </div>
                    </div>

                    <div class="appintment-type col-12" [ngClass]="{'active-type': this.selectedType == 2}" (click)="selectAppointmentType(2)"
                        [ngClass]="{'red-error-class' : isSubmitted && !selectedType}">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="booking" id="booking"
                                value="2" [checked]="selectedType == 2">
                            <label class="form-check-label w-100" for="booking">
                              {{bookingTitle}}
                            </label>
                            <label class="typ-desc" for="booking">
                              {{bookingDescription}}
                            </label>
                        </div>
                    </div>
                </div>
                <div>
                    <button class="d-flex btn-nxt mt-5" (click)="goToNext()">Next</button>
                </div>
            </div>
            <div *ngIf="isLimitReached" class="py-5 tac">
                <label class="cat-label">Please contact {{this.headData.businessName}} at {{ownerNumber}} for booking.</label>
            </div>

            <div *ngIf="isProductBlocked" class="py-5 tac">
                <label class="cat-label">{{productWarningText}}</label>
            </div>

            <!-- <div *ngIf="isLinkTurnedOff" class="py-5 tac">
                <label class="cat-label">{{linkOffMessage}}</label>
            </div> -->
            <div *ngIf="isLinkTurnedOff" class="py-5 tac link-off-container">
              <div class="logo-container d-flex">
                <img class="logo" src="assets/images/linkoff-face.svg" alt="logo">
              </div>
              <label class="cat-label mt-4">Uh oh! The link is currently unavailable.</label>
              <label class="link-off-text mt-1">Please contact {{headData.business}} via below contact details</label>

              <div class="center-block mt-5">
                <div class="row m-0" *ngIf="headData.website">
                  <label class="field-label">Website</label>
                  <label class="field-value link-color">{{headData.website}}</label>
                </div>
                <div class="row m-0" *ngIf="headData.phone">
                  <label class="field-label">Phone</label>
                  <label class="field-value">{{headData.phone}}</label>
                </div>
                <div class="row m-0" *ngIf="headData.email">
                  <label class="field-label">Email ID</label>
                  <label class="field-value link-color">{{headData.email}}</label>
                </div>
              </div>
            </div>
        </div>
    </div>

    <div>
        <app-footer-powered-by-image></app-footer-powered-by-image>
    </div>

</div>
